export default __webpack_public_path__ + "static/media/cloud-empty.f4ea1de7.png";